import * as React from 'react';
import i18n from '../i18n/config';

type State = {
  hasError: boolean;
};

export default class ErrorBoundary extends React.Component<any, any, State> {
  constructor(props: any) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  render(): React.ReactNode {
    if (this.state.hasError) {
      return <h1>{i18n.t('common.errors.somethingHasGoneWrong')}</h1>;
    }
    return this.props.children;
  }
}
